module.exports = __webpack_public_path__ + "img/icon2.4ef422ef.gif";